import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import React, {Component} from 'react'
import {FormattedDate, FormattedMessage, injectIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import Icon from "../common/icon/icon.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'
import SalesToolsTabs from "../common/layout/tabs/salestools.component.jsx"
import StandardList from '../common/listing/list.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import validator from "validator"
import {InventoryStockDocumentDefinitionAction, InventoryStockDocumentDefinitionSelector} from "../state/inventory"
import {connect} from "react-redux"
import {
    CUSTOM_FIELD_AVAILABLE_FROM_MESSAGES,
    CUSTOM_FIELD_TYPE_MESSAGES,
    getCustomFieldListingHeaders
} from "../utils/customField"

class CustomFieldDefinitionListing extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            data: [],
            loading: false,
        }
        this.getLabels = this.getLabels.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        this.refreshSearch()
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })

        if (AppContext.isInventoryEnabled()) {
            this.props.dispatch(InventoryStockDocumentDefinitionAction.fetchListing())
        }

        AppContext.getApiClient().get('/custom-field-definitions').then(r => {
            this.setState({
                data: r.data,
                loading: false,
            })
        })

    }

    getLabels(availableFromArray) {
        if (!availableFromArray) {
            return this.props.intl.formatMessage(CUSTOM_FIELD_AVAILABLE_FROM_MESSAGES["all"])
        }
        let labels = availableFromArray.map(elem => {
                if (validator.isUUID(elem)) {
                    return this.props.inventoryStockDocumentDefinitions.find(item => item.id === elem)?.name || ""

                }
                return this.props.intl.formatMessage(CUSTOM_FIELD_AVAILABLE_FROM_MESSAGES[elem])
            }
        )
        return labels.filter(elem => elem !== "").join(", ")
    }

    row(item) {
        let fieldType = this.props.intl.formatMessage(CUSTOM_FIELD_TYPE_MESSAGES[item.attributes.fieldType])
        return [
            <Link to={"/custom-field-definitions/edit/" + item.id}>{!/^[a-zA-Z]/.test(item.attributes.name) ?
                <FormattedMessage
                    id="custom_field_definition.form.edit.no_name"
                    defaultMessage="No name"
                /> : item.attributes.name}</Link>,
            this.getLabels(item.attributes.availableFrom),
            fieldType,
            <FormattedDate
                year="numeric"
                month="long"
                day="numeric"
                value={new Date(item.attributes.createdAt)}/>,
        ]
    }

    render() {
        const headers = this.state.data.length > 0 ? getCustomFieldListingHeaders() : []
        const rows = this.state.data.map(q => this.row(q))

        return (
            <div>
                <SalesToolsTabs/>
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-3 text-align-right ">
                                <Link to="/custom-field-definitions/new" className="btn btn-primary btn-sm">
                                    <Icon value={"plus-circle"}/>
                                    <FormattedMessage
                                        id="custom_field_definition.listing.add_custom_field_btn"
                                        defaultMessage="Add custom field"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.loading ?
                    <LoadingSpinner/> :
                    <StandardList
                        className="row pt-3"
                        headers={headers}
                        rows={rows}
                    />
                }
            </div>
        )
    }
}

const mapState = (state, props) => {
    return {
        ...props,
        inventoryStockDocumentDefinitions: InventoryStockDocumentDefinitionSelector.getListing(state),
    }
}
const mapDispatch = (dispatch) => {
    return {
        dispatch: dispatch
    }
}
export default connect(mapState, mapDispatch)(injectIntl(CustomFieldDefinitionListing))


// WEBPACK FOOTER //
// ./src/custom-field/listing.component.jsx